<template>
  <a-modal
    :title="title"
    :width="1180"
    :visible="visible"
    :maskClosable="false"
    :confirmLoading="loading"
    @ok="this.ok"
    @cancel="() => { $emit('cancel') }"
  >
    <a-spin :spinning="loading">
      <a-form :form="form" v-bind="formLayout">
        <a-row>
          <a-col :span="24">
            <a-divider orientation="left">
              关联信息
            </a-divider>
          </a-col>
          <a-col :span="12">
            <a-form-item label="采销全流程" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-select
                :show-arrow="false"
                :filter-option="false"
                :not-found-content="projectFetching ? undefined : null"
                show-search
                v-decorator="[
                  'project_id',
                  {
                    rules: [
                      { required: true, message: '选择' },
                    ],
                  },
                ]"
                placeholder="请输入名称"
                @search="this.projectSearch"
                @change="handleProjectChange"
              >
                <a-spin v-if="projectFetching" slot="notFoundContent" size="small" />
                <a-select-option v-for="d in projectList" :key="d.id">
                  {{ d.name }}（{{ d.number }}）
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="购销合同" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-select
                v-decorator="[
                  'sell_contract_id',
                  {
                    rules: [
                      { required: true, message: '请选择' }
                    ],
                  },
                ]"
                placeholder="选择"
                show-search
                option-filter-prop="children"
                :filter-option="filterOption"
              >
                <a-spin v-if="sellContractFetching" slot="notFoundContent" size="small" />
                <a-select-option :key="key" :value="val.id" v-for="(val, key) in sellContractList">{{ val.name }}（{{ val.number }}）</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-divider orientation="left">
              合同信息
            </a-divider>
          </a-col>
          <a-col :span="12">
            <a-form-item label="系统编号" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input v-decorator="['business_no', {rules: [{required: true, message: '必填项，请填写信息'}, {max:32, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="合同号" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input style="width: 60%" v-decorator="['contract_number', {rules: [{required: true, message: '必填项，请填写信息'}, {max:64, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
              <a-button style="margin-left: 5px;" @click="generateContractNumber" :loading="generateLoading">生成合同号</a-button>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="合同名称" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input v-decorator="['contract_name', {rules: [{required: true, message: '必填项，请填写信息'}, {max:32, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="监装公司名称" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input v-decorator="['loading_supervision_company', {rules: [{required: false, message: '必填项，请填写信息'}, {max:128, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="服务内容" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input v-decorator="['service_content', {rules: [{required: false, message: '必填项，请填写信息'}, {max:128, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-divider orientation="left">
              支付信息
            </a-divider>
          </a-col>
          <a-col :span="12">
            <a-form-item label="支付方式" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-select
                v-decorator="[
                  'payment_method',
                  {
                    rules: [
                      { required: true, message: '请选择' }
                    ],
                  },
                ]"
                placeholder="选择"
                show-search
                option-filter-prop="children"
                :filter-option="filterOption"
              >
                <a-select-option :key="key" :value="key" v-for="(val, key) in this.$Dictionaries.trade_payment_method">{{ val }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="计费方式" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input allow-clear v-decorator="['billing_method', {rules: [{required: false, message: '必填项，请填写信息'}, {max:64, message: '输入超出长度限制'}]}]" placeholder="请输入" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="支付周期" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input allow-clear v-decorator="['payment_cycle', {rules: [{required: false, message: '必填项，请填写信息'}, {max:64, message: '输入超出长度限制'}]}]" placeholder="请输入" />
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-divider orientation="left">
              财务信息
            </a-divider>
          </a-col>
          <a-col :span="12">
            <a-form-item label="税率" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
              <a-input-number allow-clear v-decorator="['tax_rate', {initialValue: 0, rules: [{required: false, message: '必填项，请填写信息'}]}]"/>%
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-divider orientation="left">
              审批信息
            </a-divider>
          </a-col>
          <a-col :span="12">
            <a-form-item label="开启审批">
              <a-switch v-decorator="['is_approval_needed', { initialValue: false, valuePropName: 'checked' }]" />
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-divider orientation="left">
              附件信息
            </a-divider>
          </a-col>
          <a-col :span="12">
            <a-form-item label="合同附件">
              <a-button icon="plus" @click="handleAddAttachment(1)">新建</a-button>
              <a-table
                bordered
                :data-source="otherData.attachment"
                :columns="attachmentColumns"
                v-if="this.otherData.attachment.length > 0"
                :pagination="false"
                key="key">
                <template slot="action" slot-scope="text, record">
                  <a-popconfirm
                    v-if="otherData.attachment.length"
                    title="确定删除?"
                    @confirm="() => onAttachmentDelete(1, record.key)"
                  >
                    <a href="javascript:;">删除</a>
                  </a-popconfirm>
                </template>
              </a-table>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="发票其他文件">
              <a-button icon="plus" @click="handleAddAttachment(2)">新建</a-button>
              <a-table
                bordered
                :data-source="otherData.invoice_attachment"
                :columns="attachmentColumns"
                v-if="this.otherData.invoice_attachment.length > 0"
                :pagination="false"
                key="key">
                <template slot="action" slot-scope="text, record">
                  <a-popconfirm
                    v-if="otherData.invoice_attachment.length"
                    title="确定删除?"
                    @confirm="() => onAttachmentDelete(2, record.key)"
                  >
                    <a href="javascript:;">删除</a>
                  </a-popconfirm>
                </template>
              </a-table>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
      <attachment-create-form
        ref="attachmentCreateForm"
        @cancel="handleAddCancel"
        @ok="handleOk"
        :record="mdl"
        :visible="visibleFrom"
        v-if="visibleFrom"
        :loading="confirmLoadingFrom"
        :model="mdl" />
      <choose-contract-number-form
        ref="chooseContractNumberForm"
        @cancel="handleChooseCancel"
        @ok="handleChooseOk"
        :visible="visibleChooseFrom"
        v-if="visibleChooseFrom"
        :loading="confirmLoadingFrom"
        :model="mdl"/>
    </a-spin>
  </a-modal>
</template>

<script>
import pick from 'lodash.pick'
import debounce from 'lodash/debounce'
import AttachmentCreateForm from '../attachment/modules/CreateForm'
import ChooseContractNumberForm from '../../sell_contract/modules/ChooseContractNumberForm'
import { sell_contract_list } from '@/api/trade_sell_contract'
import { project_list } from '@/api/trade_project'
import { tradeGenerateContractNumber } from '@/utils/util'

// 表单字段
const fields = ['id', 'host_corporation_id', 'category_id', 'business_no', 'name', 'credit', 'cash']
export default {
  components: {
    AttachmentCreateForm,
    ChooseContractNumberForm
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      default: () => false
    },
    model: {
      type: Object,
      default: () => null
    }
  },
  data () {
    this.formLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 }
      }
    }
    this.projectSearch = debounce(this.handleProjectSearch, 800)
    return {
      projectFetching: false,
      sellContractFetching: false,
      generateLoading: false,
      visibleChooseFrom: false,
      selectedProjectId: undefined,
      projectList: [],
      sellContractList: [],
      pricingCurrency: undefined,
      form: this.$form.createForm(this),
      mdl: {},
      otherData: {
        attachment: [],
        invoice_attachment: []
      },
      visibleFrom: false,
      confirmLoadingFrom: false,
      attachmentColumns: [
        {
          title: '名称',
          width: 100,
          ellipsis: true,
          dataIndex: 'name'
        },
        {
          title: '附件',
          dataIndex: 'url'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '150px',
          scopedSlots: { customRender: 'action' }
        }
      ]
    }
  },
  created () {
    console.log('custom modal created', this.form)
    // 防止表单未注册
    fields.forEach(v => this.form.getFieldDecorator(v))
    // 当 model 发生改变时，为表单设置值
    // this.$watch('model', () => {
    //   this.model && this.form.setFieldsValue(pick(this.model, fields))
    // })
    this.model && this.form.setFieldsValue(pick(this.model, fields))
    this.handleSellContractSearch(undefined)
  },
  computed: {
    formItemLayout () {
      const { formLayout } = this
      return formLayout === 'horizontal'
        ? {
          labelCol: { span: 8 },
          wrapperCol: { span: 16 }
        } : {}
    },
    title () {
      return '新建监装合同'
    }
  },
  methods: {
    handleSellContractSearch () {
      if (this.selectedProjectId === undefined) {
        return
      }
      this.sellContractFetching = true
      sell_contract_list({ project_id: this.selectedProjectId, is_expired: false, page: 1, page_size: 999 }).then((res) => {
        const result = res.data.entries || []
        this.sellContractList = result
      }).finally(() => {
        this.sellContractFetching = false
      })
    },
    handleSellContractChange (value) {
      console.log(value)
      if (value === undefined) {
        this.handleSellContractSearch(value)
      }
    },
    handleProjectSearch (value) {
      this.projectFetching = true
      this.projectList = []
      project_list({ name: value }).then((res) => {
        const result = res.data.entries || []
        this.projectList = !value ? (result.length > 5 ? result.slice(0, 5) : result) : result
      }).finally(() => {
        this.projectFetching = false
      })
    },
    handleProjectChange (value) {
      console.log(value)
      if (value === undefined) {
        this.handleProjectSearch(value)
      } else {
        this.selectedProjectId = value
        this.selectedProject = this.projectList.filter(item => item.id === this.selectedProjectId)[0]
        this.sellContractList = []
        this.form.setFieldsValue({
          sell_contract_id: undefined
        })
        this.form.setFieldsValue({
          client_ids: undefined
        })
        this.handleSellContractSearch()
      }
    },
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    handleAddAttachment (type) {
      this.mdl['type'] = type
      this.visibleFrom = true
    },
    onAttachmentDelete (type, key) {
      if (type === 1) {
        const dataSource = [...this.otherData.attachment]
        this.otherData.attachment = dataSource.filter(item => item.key !== key)
      } else if (type === 2) {
        const dataSource = [...this.otherData.invoice_attachment]
        this.otherData.invoice_attachment = dataSource.filter(item => item.key !== key)
      }
    },
    handleAddCancel () {
      this.visibleFrom = false
      const form = this.$refs.attachmentCreateForm.form
      form.resetFields() // 清理表单数据（可不做）
    },
    handleOk (date) {
      const form = this.$refs.attachmentCreateForm.form
      form.validateFields((errors, values) => {
        if (!errors) {
          console.log('values', values, date)
          // 新增
          values.url = values.url.fileList[0].url
          const current_date = new Date()
          values.key = current_date.getHours() + '' + current_date.getMinutes() + '' + current_date.getSeconds()
          if (this.mdl['type'] === 1) {
            this.otherData.attachment.push(values)
          } else if (this.mdl['type'] === 2) {
            this.otherData.invoice_attachment.push(values)
          }
          this.visibleFrom = false
          form.resetFields()
        }
      })
    },
    ok () {
      const attachment = []
      if (this.otherData.attachment) {
        this.otherData.attachment = this.otherData.attachment.map(item => {
          item.key = undefined
          item.file_type = 1
          return item
        })
        attachment.push(...this.otherData.attachment)
      }
      if (this.otherData.invoice_attachment) {
        this.otherData.invoice_attachment = this.otherData.invoice_attachment.map(item => {
          item.key = undefined
          item.file_type = 2
          return item
        })
        attachment.push(...this.otherData.invoice_attachment)
      }
      this.$emit('ok', attachment)
    },
    pricingCurrencyChange (value) {
      this.pricingCurrency = value
    },
    handleChooseCancel () {
      this.visibleChooseFrom = false
      const form = this.$refs.chooseContractNumberForm.form
      form.resetFields() // 清理表单数据（可不做）
    },
    handleChooseOk () {
      const form = this.$refs.chooseContractNumberForm.form
      form.validateFields((errors, values) => {
        if (!errors) {
          console.log('values', values)
          // 新增
          this.form.setFieldsValue({
            contract_number: values['contract_number']
          })
          this.visibleChooseFrom = false
          form.resetFields()
        }
      })
    },
    generateContractNumber () {
      if (this.selectedProjectId === undefined) {
        this.$message.warning('选择采销全流程')
        return
      }
      this.generateLoading = true
      tradeGenerateContractNumber(this, this.selectedProjectId, () => {
        this.generateLoading = false
      }).then(data => {
        if (typeof data === 'object') {
          if (data.length === 1) {
            this.form.setFieldsValue({
              contract_number: '' + data[0]['contract_number']
            })
          } else {
            this.visibleChooseFrom = true
            this.mdl['list'] = data
          }
        } else {
          this.form.setFieldsValue({
            contract_number: '' + data
          })
        }
      })
    }
  }
}
</script>
